import { Component, h } from 'preact';
import { Inquiry, InquiryDocument } from '../../../../../types/inquiries';
import { InqUploadContractModal } from './inq-upload-contract-modal.component';
import { ReqState } from '../../../../../types';
import { inquiryService } from '../../../../utils/inquiry.service';

interface InqUploadContractModalHostProps {
  inquiry: Inquiry,
  
  onClose: () => void;
}

interface InqUploadContractModalHostState {
  contractsReqState?: ReqState;
  contractChoices?: InquiryDocument[];

  submitState?: ReqState;
}

export class InqUploadContractModalHost extends Component<InqUploadContractModalHostProps, InqUploadContractModalHostState> {
  async componentDidMount() {
    try {
      this.setState({ contractsReqState: ReqState.IN_PROGRESS });
      const contracts = await inquiryService.getContracts(this.props.inquiry.inquiryCode);
      this.setState({
        contractChoices: contracts.results,
        contractsReqState: ReqState.SUCCESS
      });
    } catch (err) {
      this.setState({ contractsReqState: ReqState.FAILED });
      console.error(err);
    }
  }

  async onSubmit(contractKey: string, date: string, files: FileList, amount: number) {
    console.log(contractKey, files, amount);

    try {
      this.setState({ submitState: ReqState.IN_PROGRESS });

      await inquiryService.markContractAsDealWon(
        this.props.inquiry.inquiryCode,
        contractKey,
        null,
        amount
      );
      await inquiryService.uploadContractImageFiles(
        this.props.inquiry.inquiryCode,
        contractKey,
        files
      );

      this.setState({ submitState: ReqState.SUCCESS });
    } catch (err) {
      this.setState({ submitState: ReqState.FAILED });
      console.log(err);
    }
  }

  render(props: InqUploadContractModalHostProps, state: InqUploadContractModalHostState) {
    return (
      <InqUploadContractModal onClose={ this.props.onClose }
        contractsReqState={ state.contractsReqState }
        contractChoices={ state.contractChoices }
        submitState={ this.state.submitState }
        onSubmit={ (key, date, files, amount) => this.onSubmit(key, date, files, amount)} />
    );
  }
}
